<ngx-ui-loader />
<p-toast key="errorToast" position="top-right"> </p-toast>
@if (!isMobileRedirect) {
    <nav-strip [collapsed]="collapsed()" />
}
<div class="main-content">
    <mat-sidenav-container autosize>
        @if (!isMobileRedirect) {
            <mat-sidenav mode="side" [opened]="isSideNavOpen">
                <custom-side-nav [userDetails]="userDetails()" [(collapsed)]="collapsed" />
            </mat-sidenav>
        }
        <mat-sidenav-content>
            @if (!isMobileRedirect) {
                <toolbar [(userDetails)]="userDetails" [(activeRoleDisplayName)]="activeRoleDisplayName" [sidenav]="sidenav" />
            }
            <div [class]="{ 'p-0': isMobileRedirect, pages: !isMobileRedirect }">
                <router-outlet />
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
